/**
 * Created by danielgw on 28/10/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var BaseController = require('web-agent-assets-js/BaseController');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////


    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    var AgentGroupDataManager = BaseController.extend(function agentGroupDataManager(options) {
        var that = this;
        if (options) {
            this.model = options.model;
        }

        this.agentManagerModel = _getAgentManagerModel(true);

        // If we're running after the first fetch - get the current data so we don't wait for the next fetch
        if (this.agentManagerModel.getFetchState() === this.agentManagerModel.FetchState.SUCCESS) {
            _agentGroupIdsUpdate.call(this);
            _agentsUpdate.call(this);
        }
        // bind to changes on agentGroup
        this.agentManagerModel.listenTo(this.agentManagerModel, "change:"+this.agentManagerModel.KEYS.AGENT_GROUP_IDS, _agentGroupIdsUpdate.bind(this));

        // bind to changes on agentIds in the data module
        this.agentManagerModel.listenTo(this.agentManagerModel, "change:" + this.agentManagerModel.KEYS.USER_IDS, _agentsUpdate.bind(this));

        // if LPA user, need to get the agent group list form sessionManager and not form AC
        if (window.lpTag.WebAgent.logicController.isLPA()) {
            var agentGroupArray = that.getAllGroupsNames();
            that.model.set("agent.agentGroups.array", agentGroupArray);
        }
    });
    /**
     * Return the data module
     * @returns {*}
     * @private
     */
    function _getAgentManagerModel(useV3Version) {
        return useV3Version ? LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentManagerModelV3)
                            : LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAgentManagerModel);
    }


    function _agentGroupIdsUpdate() {
        var agentGroupArray = this.getGroupsNames();
        this.model.set("agent.agentGroups.array", agentGroupArray);
    }

    function _agentsUpdate() {
        var agentsArray = this.getAgentNames();
        this.model.modify("operators.underManagementArray", agentsArray, "id");
    }
    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////

    AgentGroupDataManager.prototype.applicationType = 'AgentGroupDataManager';

    /**
     * Return array of agent group that the agent can filter by
     * @returns {Array[{id,displayName}]}
     */
    AgentGroupDataManager.prototype.getGroupsNames = function () {
        var agentGroupNameList = window.lpTag.WebAgent.logicController.getAgentGroupsById();
        var agentGroupsArray = [];
        var agentGroupIds = this.getGroupIds();
        _.each(agentGroupIds, function(item, index) {
            if (agentGroupNameList[item]) { // if we didn't get the name in the login, we won't return the group
                agentGroupsArray.push({id: item, displayName: agentGroupNameList[item]});
            }
        });
        return agentGroupsArray;
    };

    AgentGroupDataManager.prototype.getAllGroupsNames = function () {
        var agentGroupData = agentLEManager.getAgentGroupsData();
        var agentGroupsArray = [];
        if (agentGroupData && agentGroupData.items) {
            $.each(agentGroupData.items, function(i, item){
                agentGroupsArray.push({id: item.id, displayName: item.name});
            });
            return agentGroupsArray;
        }
        return [];
    };

    /**
     * Return the agent group ids that the agent can filter by from the data module
     * @returns {*}
     */
    AgentGroupDataManager.prototype.getGroupIds = function () {
        return this.agentManagerModel.getGroups();
    };


    /**
     * Return array of agent name that the agent can filter by
     * @returns {Array[{id,displayName}]}
     */
    AgentGroupDataManager.prototype.getAgentNames = function () {
        var that = this;
        var agentArray = [];
        if (window.lpTag.WebAgent.logicController.isLPA()) {
            agentArray = this.model.get('operators.array');
        } else {
            var agents = this.getAgents();
            _.each(agents, function(item, index) {
                var agentObject = {};
                    agentObject.id = item.id;
                    agentObject.displayName = item.fullName;
                    agentObject.agentGroupId = (item.memberOf) ? item.memberOf.agentGroupId : null;
                    agentObject.skillIds = item.skillIds;
                    agentObject.deleted = item.deleted;
                    agentObject.fullName = item.fullName;
                    agentObject.nickname = item.nickname;

                if (agentObject.id && agentObject.displayName) { // if we didn't get the name the item won't be added to the array
                    agentArray.push(agentObject);
                }
            });
        }
        return agentArray;
    };

    /**
     * Return the agent ids that the agent can filter by from the data module
     * @returns {*}
     */
    AgentGroupDataManager.prototype.getAgents = function () {
        return this.agentManagerModel.getAgents();
    };


    return AgentGroupDataManager;

});
